import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/schedule",
  },
  {
    path: "/login",
    name: "ScheduleLogin",
    component: () => import("@/views/Login.vue"),
    meta: { title: "Schedule Assist Login" },
  },
  {
    path: "/schedule",
    name: "ScheduleRequest",
    component: () => import("@/views/ScheduleRequest.vue"),
    meta: { title: "Staff Schedule Request" },
  },
  {
    path: "/records",
    name: "ScheduleRecords",
    component: () => import("@/views/ScheduleRecords.vue"),
    meta: { title: "My Schedule Requests" },
  },
  {
    path: "/success",
    name: "SubmitSuccess",
    component: () => import("@/views/SubmitSuccess.vue"),
    meta: { title: "Request Submitted" },
  },
  {
    path: "*",
    redirect: "/schedule",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Staff Schedule";
  next();
});

export default router;
